// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text_wrapper__2r4IQ","boxWrapper":"Text_boxWrapper__11mRv","noIndent":"Text_noIndent__3b9_C","alert":"Text_alert__25V4N"};